import { render, staticRenderFns } from "./SubjectsDropdown.vue?vue&type=template&id=7b39b72d&"
import script from "./SubjectsDropdown.vue?vue&type=script&lang=ts&"
export * from "./SubjectsDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports